import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllDonationFilters } from './useDonationFilter';

export const BULK_DELETE_DONATION_LIMIT = 10000;

export interface IBulkDeleteDonationsResult {
	deletedCount: number;
}

interface IUseBulkDeleteDonationsMutationOptions {
	onSuccess?: (data: IBulkDeleteDonationsResult) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export const useBulkDeleteDonationsMutation = ({
	onSuccess,
	onError,
	impersonationContext,
}: IUseBulkDeleteDonationsMutationOptions = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (filter: Api.IDonationFilterRequest) => {
			return userSession.webServiceHelper.callAsync<IBulkDeleteDonationsResult>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'donation/bulkDelete',
				}),
				'POST',
				filter
			);
		},
		onSuccess: data => {
			invalidateAllDonationFilters();
			onSuccess?.(data);
		},
		onError,
	});
};
